var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { env } from '../environment';
import style from '../css/link_css';
let Link = class Link extends LitElement {
    constructor() {
        super(...arguments);
        this.type = '';
        this.mode = '';
        this.href = '#';
        this.text = '';
        this.target = '_self';
    }
    static get styles() {
        if (env.debug) {
            return css ``;
        }
        return [style];
    }
    _textWithIcon() {
        if (this.type == 'standalone') {
            return html `${this.text}
        <gs1-fa-icon family="far" type="fa-arrow-right"></gs1-fa-icon>`;
        }
        if (this.type == 'download') {
            return html `<gs1-fa-icon
          family="far"
          type="fa-arrow-to-bottom"
        ></gs1-fa-icon>
        ${this.text}`;
        }
        return html `${this.text}`;
    }
    _data_has_background() {
        return this.mode == 'negative';
    }
    _debug() {
        return env.debug
            ? html `<link rel="stylesheet" href="/css/link.css" />`
            : html ``;
    }
    render() {
        return html `
      ${this._debug()}
      <a
        class="${this.type}"
        ?data-has-background="${this._data_has_background()}"
        href="${this.href}"
        target="${this.target}"
        >${this._textWithIcon()}</a
      >
    `;
    }
};
__decorate([
    property()
], Link.prototype, "type", void 0);
__decorate([
    property()
], Link.prototype, "mode", void 0);
__decorate([
    property()
], Link.prototype, "href", void 0);
__decorate([
    property()
], Link.prototype, "text", void 0);
__decorate([
    property()
], Link.prototype, "target", void 0);
Link = __decorate([
    customElement('gs1-link')
], Link);
export { Link };
//# sourceMappingURL=link.js.map